<template>
  <modal :height="250" :width="400" name="modalQuestion">
    <div class="modalStyle">
      <h4 class="card-title">Question</h4>
      <form id="formQuestion">
        <div class="form-group">
          <div class="col-md-12">
            <h4>{{ text }}</h4>
          </div>
        </div>
        <div class="buttonModal">
          <button class="btn btn-info btn-fill float-left" id="buttonOk" v-on:click="clickOk()">
            OK
          </button>
          <button class="btn btn-info btn-fill float-right" v-on:click="clickClose()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'l-modal-question',
    props: {
      isAdmin: false
    },
    data() {
      return {
        item: null,
        handler: null,
        text: ''
      }
    },
    methods: {
      openModalQuestion(text, item, handler) {
        this.item = item;
        this.handler = handler;
        this.text = text;
        this.$modal.show('modalQuestion');
      },
      closeModal() {
        this.$modal.hide('modalQuestion');
      },
      clickOk() {
        this.closeModal();

        if(this.handler !== null) {
          this.handler(this.item);
        }
      },
      clickClose() {
        this.closeModal();
      }
    }
  }
</script>

<style scoped>
  #buttonOk {
    margin-left: 57%;
  }

</style>
